import React, { useState, useEffect } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink } from "react-router-dom";
import AccountsMenu from "./AccountsMenu";
import YearsDropDown from "../Shared/YearsDropDown";
import config from "../../Config";
import { toast, ToastContainer } from "react-toastify";

function TransferAccounts() {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [defaultYear, setDefaultYear] = useState(
    localStorage.getItem("DefaultFYear")
  );
  const [sourceYear, setSourceYear] = useState("");
  const [targetYear, setTargetYear] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const [obSourceYear, setObSourceYear] = useState("");
  const [obTargetYear, setObTargetYear] = useState("");
  const [obLoading, setObLoading] = useState(false);
  const [obResult, setObResult] = useState(null);

  useEffect(() => {
    if (defaultYear) {
      setSourceYear(defaultYear);
      const parsed = parseInt(defaultYear, 10);
      if (!Number.isNaN(parsed)) {
        setTargetYear(String(parsed + 1));
      }
      setObSourceYear(defaultYear);
      if (!Number.isNaN(parsed)) {
        setObTargetYear(String(parsed + 1));
      }
    }
  }, [defaultYear]);

  const handleTransfer = () => {
    if (!sourceYear || !targetYear) {
      toast.error("Please select source and target years.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (sourceYear === targetYear) {
      toast.error("Source and target year must be different.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      SourceYear: parseInt(sourceYear, 10),
      TargetYear: parseInt(targetYear, 10),
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Accounts/TransferAccountsToNewYear",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setResult(response.data);
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          setResult(null);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleTransferOpeningBalances = () => {
    if (!obSourceYear || !obTargetYear) {
      toast.error("Please select source and target years for opening balances.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (obSourceYear === obTargetYear) {
      toast.error("Source and target year must be different.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setObLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      SourceYear: parseInt(obSourceYear, 10),
      TargetYear: parseInt(obTargetYear, 10),
    };

    axios({
      method: "post",
      url: config.base_url + "Accounts/TransferOpeningBalancesToNewYear",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setObResult(response.data);
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          setObResult(null);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setObLoading(false);
      })
      .catch(function () {
        setObLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <>
      <AccountsMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Transfer Accounts
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Transfer Accounts</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body p-md-4">
                <div className="row gy-3">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Source Year:</label>
                      <select
                        className="form-select"
                        value={sourceYear}
                        onChange={(e) => {
                          setSourceYear(e.target.value);
                          const parsed = parseInt(e.target.value, 10);
                          if (!Number.isNaN(parsed)) {
                            setTargetYear(String(parsed + 1));
                          }
                        }}
                      >
                        <option value="">Please Select</option>
                        <YearsDropDown selected={sourceYear} />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Target Year:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={targetYear}
                        onChange={(e) => setTargetYear(e.target.value)}
                        placeholder="e.g. 2026"
                      />
                    </div>
                  </div>
                  <div className="col-md-3 align-self-end">
                    <div className="form-group">
                      {loading ? (
                        <Spinner animation="border" role="status" />
                      ) : (
                        <button
                          type="button"
                          className="button button-primary w-100"
                          onClick={handleTransfer}
                        >
                          Transfer Accounts
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {result && (
                  <div className="mt-4">
                    <h5>Transfer Summary</h5>
                    <table className="table table-sm table-bordered">
                      <tbody>
                        <tr>
                          <th>Source Year</th>
                          <td>{result.SourceYear}</td>
                        </tr>
                        <tr>
                          <th>Target Year</th>
                          <td>{result.TargetYear}</td>
                        </tr>
                        <tr>
                          <th>Created Accounts</th>
                          <td>{result.CreatedCount}</td>
                        </tr>
                        <tr>
                          <th>Updated Parent Links</th>
                          <td>{result.UpdatedParentCount}</td>
                        </tr>
                        <tr>
                          <th>Skipped Existing</th>
                          <td>{result.SkippedExistingCount}</td>
                        </tr>
                      </tbody>
                    </table>
                    {result.MissingParentCodes &&
                      result.MissingParentCodes.length > 0 && (
                        <div className="alert alert-warning">
                          Missing parent accounts for codes:{" "}
                          {result.MissingParentCodes.join(", ")}
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>

            <div className="card mt-4">
              <div className="card-body p-md-4">
                <h5 className="mb-2">Transfer opening balances</h5>
                <p className="text-muted small mb-3">
                  For each <strong>level-3</strong> account in the <strong>source</strong> year, the system
                  calculates <strong>closing balance</strong> (opening in that year plus all vouchers
                  through <strong>31 March</strong> of the following calendar year — same basis as trial
                  balance). That closing is written as the <strong>opening debit/credit</strong> for the
                  matching account code in the <strong>target</strong> year, only when no opening row
                  exists yet for that account and year. Run <strong>Transfer Accounts</strong> above first
                  if the target year&apos;s chart is missing. Review or edit on{" "}
                  <NavLink to="/Accounts/OpeningBalances">Opening Balances</NavLink>.
                </p>
                <div className="row gy-3">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Source year (balances from)</label>
                      <select
                        className="form-select"
                        value={obSourceYear}
                        onChange={(e) => {
                          setObSourceYear(e.target.value);
                          const parsed = parseInt(e.target.value, 10);
                          if (!Number.isNaN(parsed)) {
                            setObTargetYear(String(parsed + 1));
                          }
                        }}
                      >
                        <option value="">Please Select</option>
                        <YearsDropDown selected={obSourceYear} />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Target year (openings into)</label>
                      <input
                        type="number"
                        className="form-control"
                        value={obTargetYear}
                        onChange={(e) => setObTargetYear(e.target.value)}
                        placeholder="e.g. 2026"
                      />
                    </div>
                  </div>
                  <div className="col-md-3 align-self-end">
                    <div className="form-group">
                      {obLoading ? (
                        <Spinner animation="border" role="status" />
                      ) : (
                        <button
                          type="button"
                          className="button button-primary w-100"
                          onClick={handleTransferOpeningBalances}
                        >
                          Transfer opening balances
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {obResult && (
                  <div className="mt-4">
                    <h6 className="mb-2">Opening balance transfer summary</h6>
                    <table className="table table-sm table-bordered">
                      <tbody>
                        <tr>
                          <th>Source year</th>
                          <td>{obResult.SourceYear}</td>
                        </tr>
                        <tr>
                          <th>Target year</th>
                          <td>{obResult.TargetYear}</td>
                        </tr>
                        <tr>
                          <th>New opening rows created</th>
                          <td>{obResult.CreatedOpeningBalanceCount}</td>
                        </tr>
                        <tr>
                          <th>Skipped (already had opening in target year)</th>
                          <td>{obResult.SkippedExistingOpeningBalanceCount}</td>
                        </tr>
                        <tr>
                          <th>Skipped (no matching account in target year)</th>
                          <td>{obResult.SkippedMissingTargetAccountCount}</td>
                        </tr>
                        <tr>
                          <th>Skipped (zero closing in source year)</th>
                          <td>{obResult.SkippedZeroClosingCount}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TransferAccounts;
